import React from 'react';
import LegalPage from './LegalPage';
import termsData from '../data/termsOfService';

const TermsOfService = () => <LegalPage data={termsData} />;

export default TermsOfService;
